export const SortHelper = {
  sortHistory: (billingData, auditData) =>
    [...billingData, ...auditData].sort(
      (billing, audit) => new Date(audit?.createdAt) - new Date(billing?.createdAt),
    ),
};
